import React, { useState, useEffect } from 'react';
import axios from "axios";
import { withRouter } from 'react-router-dom';
import {
    GridComponent, ColumnsDirective, ColumnDirective,
    Inject, Page, Sort, Toolbar
} from "@syncfusion/ej2-react-grids";
import { connect } from 'react-redux';

const CallHistory = ({ custInfo }) => {
    const cId = parseInt(custInfo.map((item) => item.custId));    
    const [customerCalls, setcustomerCalls] = useState([]);
    const [paging, setPaging] = useState(false);
    useEffect(() => {
        axios
            .get(`${process.env.REACT_APP_BACKEND_BASE_URL}/CallDetails/GetCallByCustomerId/` + cId)
            .then((response) => {
                setcustomerCalls(response.data);                
                if (response.data.length > 5) {
                    setPaging(true);
                }
            });
    }, []);    

    const toolbarOptions = [
        "Search"
    ];
    const pageSettingsOptions = {
        pageCount: 3, pageSize: 5, pageSizes: true
    };       

    return (
        <div className="int-container">
            <div class="container">
                <div class="form-container-large" style={{ width: "100%" }}>
                    <div class="form-group">
                        <h3 style={{ color: "#f19f1f", width: "100%", textAlign: "center" }}>Call History</h3>
                    </div>
                    <div>                        
                        <GridComponent dataSource={customerCalls} allowSorting={true} height='auto'  
                            allowPaging={paging} pageSettings={pageSettingsOptions} toolbar={toolbarOptions} >
                            <ColumnsDirective>
                                <ColumnDirective field='callID' headerText='Call Id' width='50' textAlign='left' visible={false} />
                                <ColumnDirective field='petID' headerText='Pet Id' width='50' textAlign='left' visible={false} />
                                <ColumnDirective field='petName' headerText='Pet Name' width='150' textAlign='left' />
                                <ColumnDirective field='callDate' headerText='Date' width='120' textAlign='left' type='datetime' format='MM/dd/yyyy' />
                                <ColumnDirective field='startTime' headerText='Start Time' width='130' textAlign='left' />
                                <ColumnDirective field='endTime' headerText='End Time' width='120' textAlign='left' />
                                <ColumnDirective field='notes' headerText='Notes' textAlign='left' />                                
                            </ColumnsDirective>
                            <Inject services={[Page, Sort, Toolbar]} />
                        </GridComponent>
                    </div>
                </div>
            </div>
        </div>
    );
}

const mapStateToProps = ({ login: { custInfo } }) => ({
    custInfo
})

export default connect(mapStateToProps)(withRouter(CallHistory));